var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SelecaoDeProjetoDeSubsidio.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-715517fd\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SelecaoDeProjetoDeSubsidio.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/app/src/components/selecao-de-projeto-de-subsidio/SelecaoDeProjetoDeSubsidio.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SelecaoDeProjetoDeSubsidio.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-715517fd", Component.options)
  } else {
    hotAPI.reload("data-v-715517fd", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/selecao-de-projeto-de-subsidio/SelecaoDeProjetoDeSubsidio.vue
// module id = 1072
// module chunks = 1